import {createSuggestRepository} from '@yandex-delivery/api/repo/suggest'
import {createSuggestService} from '@yandex-delivery/api/service/suggest'
import {externalApiURL} from '@yandex-delivery/client-core/api/corp'
import {addQuery} from '@yandex-delivery/utils'

import {appConfig} from '../../config'
import {fetch} from '../fetch'

type FetchFunction = typeof fetch

const withExternalApiPrefix = (fetchFn: FetchFunction): FetchFunction => {
  return config => {
    return fetchFn({
      ...config,
      url: externalApiURL(config.url),
    })
  }
}

const withCountryCode = (fetchFn: FetchFunction): FetchFunction => {
  return config => {
    return fetchFn({
      ...config,
      url: addQuery(config.url, {country: appConfig.countryCode}),
    })
  }
}

const suggestRepository = createSuggestRepository({
  fetch: withCountryCode(withExternalApiPrefix(fetch)),
})

export const suggestService = createSuggestService(suggestRepository)
